export const SPACEBAR = ' ';

export const INTERACTIVE_ELEMENTS = [
    'BUTTON',
    'INPUT',
    'OPTION',
    'SELECT',
    'TEXTAREA',
];

export function isInteractiveElement(target: Element): boolean {
    return target && INTERACTIVE_ELEMENTS.includes(target.tagName);
}
